import type { MouseEvent } from "react";
import { RedirectionUrls, RedirectStatus } from "./ClientRedirect.types";
import { RedirectAlreadyRedirected } from "./RedirectAlreadyRedirected";
import { RedirectAppOpenAttempted } from "./RedirectAppOpenAttempted";
import { RedirectDestinationActions } from "./RedirectDestinationActions";
import { RedirectFailed } from "./RedirectFailed";
import { RedirectSpinner } from "./RedirectSpinner";

type RedirectStatusContentProps = {
  status: RedirectStatus | null;
  os: string;
  redirectionUrls: RedirectionUrls;
  onStoreTap?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * What the fallback layout shows once the automatic redirect is out of the
 * picture — still in flight, already used, failed, or replaced by an attempt
 * to open the app.
 */
export function RedirectStatusContent({
  status,
  os,
  redirectionUrls,
  onStoreTap,
}: RedirectStatusContentProps) {
  if (!status) return <RedirectSpinner />;

  return (
    <div className="flex flex-col items-center gap-4">
      {status === "alreadyRedirected" ? (
        <RedirectAlreadyRedirected os={os} iosUrl={redirectionUrls.ios} />
      ) : status === "appOpenAttempted" ? (
        <RedirectAppOpenAttempted os={os} />
      ) : (
        <RedirectFailed />
      )}
      <RedirectDestinationActions
        os={os}
        iosUrl={redirectionUrls.ios}
        androidUrl={redirectionUrls.android}
        webUrl={redirectionUrls.web}
        onStoreTap={onStoreTap}
      />
    </div>
  );
}
